module.exports = __webpack_public_path__ + "media/images/smart_phone/logo_aichi-e245863072d6e6037b24abc3be2a7827.png";